import { render, staticRenderFns } from "./iSwitch.vue?vue&type=template&id=4b52c02e&scoped=true&"
import script from "./iSwitch.vue?vue&type=script&lang=js&"
export * from "./iSwitch.vue?vue&type=script&lang=js&"
import style0 from "./iSwitch.vue?vue&type=style&index=0&id=4b52c02e&lang=sass&scoped=true&"
import style1 from "./iSwitch.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52c02e",
  null
  
)

export default component.exports